export default __webpack_public_path__ + "static/media/portfolio-93.c1ddd042.jpg";